import React from "react";
import { motion } from "framer-motion";
import LoadingButton from "./LoadingButton";
import Image from "../images/Image";

interface ButtonWithImgProps {
  className?: string;
  buttonName: string;
  loading?: boolean;
  buttonType?: boolean;
  ImgSrc?: string;
  buttonOnclick?: () => void;
  ImgClass?: string;
  ui?: React.ReactNode;
  disabledButton?: boolean;
  testId?: string;
}

const ButtonWithImg: React.FC<ButtonWithImgProps> = ({
  className = "",
  loading = false,
  buttonType = false,
  buttonName,
  ImgSrc,
  testId,
  ImgClass = "",
  buttonOnclick,
  ui,
  disabledButton,
}) => {
  const buttonVariants = {
    hidden: { opacity: 0, y: 0 },
    visible: { opacity: 1, y: 0 },
    // hover: { scale: 1.05 },
    // tap: { scale: 0.95 },
  };

  return (
    <motion.button
      className={`
        h-[44px] 
        max-w-[410px] 
        gap-[8px] 
        rounded-lg
        border
        border-p_primary
        text-p_primary
        text-center
        text-body1
        ${loading ? 'disabled:bg-disable_fill disabled:border-disable_stroke disabled:text-disable_stroke disabled:cursor-not-allowed': ''}
        flex items-center
        justify-center
        ${className}
      `}
      data-testid={testId || buttonName}
      disabled={loading || disabledButton}
      type={buttonType ? "submit" : "button"}
      variants={buttonVariants}
      initial="hidden"
      animate="visible"
      whileHover="hover"
      whileTap="tap"
      onClick={buttonOnclick}
      transition={{ duration: 0.4, ease: "easeInOut" }}
      aria-label={buttonName}
    >
      {(ImgSrc && !loading) && (
        <div className={ImgClass}>
          <Image src={ImgSrc} />
        </div>
      )}
      {loading ? <LoadingButton /> : buttonName}
      {ui && <div>{ui}</div>}
    </motion.button>
  );
};

export default ButtonWithImg;